/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable require-jsdoc */
import React, { ReactNode } from 'react';
import { Modal, Toast } from '@hfzq/crab-react';
import { ModalAlertProps, ModalConfirmProps } from '@hfzq/crab-react/esm/components/modal';
import { ErrorModalContent } from '@src/components/error-modal-content';
import { SimpleToast, SuccessToastContent } from '@src/components/toast';
import { ToastHandler } from '@hfzq/crab-react/esm/components/toast';
import { CachePool } from './cache-pool';

/**
 * 显示确认弹窗
 *
 * @param msg 确认信息
 */
function alert(msg: ReactNode, option?: Omit<ModalAlertProps, 'content'>) {
  return Modal.alert({
    content: msg,
    title: '系统提示',
    ...option,
  });
}

/**
 * 显示确认选择弹窗
 *
 * @param msg 确认信息
 */
function confirm(msg: ReactNode, option?: Omit<ModalConfirmProps, 'content'>) {
  return Modal.confirm({
    content: msg,
    title: '系统提示',
    ...option,
  });
}

/**
 * 显示确认弹窗
 *
 * @param msg 确认信息
 */
function globalAlert(msg: ReactNode, option?: Omit<ModalAlertProps, 'content'>) {
  return Modal.alert({
    className: 'global-confirm',
    content: msg,
    title: '系统提示',
    ...option,
  });
}

/**
 * 显示确认选择弹窗
 *
 * @param msg 确认信息
 */
function globalConfirm(msg: ReactNode, option?: Omit<ModalConfirmProps, 'content'>) {
  return Modal.confirm({
    className: 'global-confirm',
    content: msg,
    title: '系统提示',
    ...option,
  });
}

/**
 * 关闭所有弹窗
 */
function clear() {
  Modal.clear();
}

/**
 * 处理异常信息
 * @param error DataSuccessResponse | Error
 */
function handleError(error: any) {
  if (error && error.code && error.message) {
    return Modal.alert({
      bodyClassName: 'global-error-modal-body',
      closeOnMaskClick: true,
      content: <ErrorModalContent message={error.message} detailMessage={error.detailMessage} />,
      title: '系统提示',
    });
  }
  // eslint-disable-next-line no-console
  console.error(error);
  throw error;
}

/**
 * 显示toast
 * @param msg toast 信息
 * @returns
 */
function toast(msg: ReactNode) {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      Toast.show({
        content: <SimpleToast>{msg}</SimpleToast>,
        afterClose: resolve,
        maskClassName: 'simple-toast',
      });
    }, 60);
  });
}

/**
 * 显示 success toast
 * @param msg toast 信息
 * @returns
 */
function successToast(msg: string) {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      Toast.show({
        content: <SuccessToastContent title={msg} />,
        afterClose: resolve,
      });
    }, 60);
  });
}

/**
 * 显示loading
 */
function loading() {
  return Toast.show({
    icon: 'loading',
    duration: 0,
    maskClickable: false,
  });
}

type LoadingItem = { time: number };
const loadingPool = new CachePool<LoadingItem>();
let loadingHandler: ToastHandler | null = null;
let loadingTimer: NodeJS.Timer | null = null;

function addLoading() {
  loadingPool.add({
    time: Date.now(),
  });
  if (!loadingHandler) {
    loadingHandler = Toast.show({
      icon: 'loading',
      duration: 0,
      maskClickable: false,
      maskClassName: 'auto-loading-AHSDUFHSJD',
    });
  }
}

function removeLoading(item?: LoadingItem) {
  if (item) {
    loadingPool.remove(item);
  } else {
    loadingPool.shift();
  }
  if (loadingPool.isEmpty() && loadingHandler) {
    loadingTimer = setInterval(() => {
      if (loadingHandler && document.querySelector('.auto-loading-AHSDUFHSJD')) {
        loadingHandler?.close();
        loadingHandler = null;
        loadingTimer && clearInterval(loadingTimer);
        loadingTimer = null;
      }
    }, 10);
  }
}

export const Message = {
  toast,
  successToast,
  loading,
  addLoading,
  removeLoading,
  handleError,
  alert,
  confirm,
  clear,
  globalAlert,
  globalConfirm,
};
